import styles from './Footer.module.css';



function Footer() {
    return (
        <footer className={styles.block} id='contacts'>
            <p className={styles.text}>
                Мой телеграм-канал <br /><a href='https://t.me/osipovsart' target='_blank'>Osipov’s Art</a>
            </p>
        </footer>
    );
}

export default Footer;